import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, apiError } from "./api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = loading, false = anonymous, object = authed
  const [accessToken, setAccessToken] = useState(() => localStorage.getItem("access_token") || "");

  const refreshMe = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
      return data.user;
    } catch (e) {
      setUser(false);
      return null;
    }
  }, []);

  useEffect(() => {
    refreshMe();
  }, [refreshMe]);

  const login = async (email, password) => {
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setUser(data.user);
      if (data.access_token) {
        setAccessToken(data.access_token);
        localStorage.setItem("access_token", data.access_token);
      }
      return { ok: true, user: data.user };
    } catch (e) {
      return { ok: false, error: apiError(e, "Login fehlgeschlagen") };
    }
  };

  const register = async (payload) => {
    try {
      const { data } = await api.post("/auth/register", payload);
      setUser(data.user);
      if (data.access_token) {
        setAccessToken(data.access_token);
        localStorage.setItem("access_token", data.access_token);
      }
      return { ok: true, user: data.user };
    } catch (e) {
      return { ok: false, error: apiError(e, "Registrierung fehlgeschlagen") };
    }
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (e) {
      // ignore
    }
    setUser(false);
    setAccessToken("");
    localStorage.removeItem("access_token");
  };

  return (
    <AuthContext.Provider value={{ user, accessToken, login, register, logout, refreshMe }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be inside AuthProvider");
  return ctx;
}
